import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import deepClone from 'www/vue_components/common/TheFilters/lpu/functions/deepClone'
import deepEqual from 'www/vue_components/common/TheFilters/lpu/functions/deepEqual'
import type { Filters } from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore.types'

const filtersModel: Filters = {
  lpuType: undefined,
  doctorSpeciality: undefined,
  sort: undefined,
  place: undefined,
  isHighRating: undefined,
  isOnlineAppointment: undefined,
  isClubAppointment: undefined,
  timeWork: {
    type: 'any',
  },
}

const useFiltersStore = defineStore('filtersStore', () => {
  const filters = ref<Filters>(filtersModel) // Содержит актуальные (сохранённые) фильтры
  const unsavedFilters = ref<Filters>(filtersModel) // Содержит локально изменённые (не сохранённые) фильтры, до их применения
  const isLoading = ref(false)

  const updateUnsavedFilters = (newUnsavedFilters: Partial<Filters>) => {
    unsavedFilters.value = deepClone({ ...unsavedFilters.value, ...newUnsavedFilters })
  }
  const resetUnsavedFilters = () => {
    unsavedFilters.value = filters.value
  }
  const hasUnsavedFilters = computed(() => (
    !deepEqual(
      JSON.parse(JSON.stringify(unsavedFilters.value)),
      JSON.parse(JSON.stringify(filters.value)),
    )
  ))

  const applyUnsavedFilters = () => {
    filters.value = unsavedFilters.value
  }

  const updateFilters = (newFilters: Partial<Filters>) => {
    filters.value = deepClone({ ...filters.value, ...newFilters })

    resetUnsavedFilters()
  }

  const updateLoading = (value: boolean) => {
    isLoading.value = value
  }

  return {
    isLoading,
    filters,
    unsavedFilters,
    hasUnsavedFilters,
    updateFilters,
    updateUnsavedFilters,
    resetUnsavedFilters,
    applyUnsavedFilters,
    updateLoading,
  }
})

export default useFiltersStore
